import Header from "components/Header";
import MainLayout from "layouts/Main";
import { useSelector } from "react-redux";
import { selectUserDetails } from "store/user/selector";
import JoinDocs from "../../Join/modules/Docs";

export default function UploadDocs() {
  const userDetails = useSelector(selectUserDetails);

  const submitData = {
    factoring_id: userDetails?.factoring_id
  } as any;

  return (
    <MainLayout
      desktopTitle="Finance"
      className="px-5"
      customHeader={<Header label="Upload Documents" />}>
      <JoinDocs submitData={submitData} />
    </MainLayout>
  );
}
